import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

const removeRoundtable = async ({ id }: { id: string }) => {
  try {
    await firestore.collection(DB_PATH.COMMUNITY_ROUNDTABLE).doc(id).delete();
    console.log("Roundtable removed", id);
  } catch (error) {
    console.error("Error removing roundtable:", error);
  }
};

export default removeRoundtable;
